// api/attendanceReportListApi.js
import { baseApi } from "@/utils/baseApi";  // Static import (no circular ref)
import { API_ENDPOINTS } from "@/api/services/attendance/apiEndPoint";

// 👇 Inject ONCE (not inside a component/hook)
export const attendanceReportListApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAttendanceReport: builder.query({
      query: ({ month, sortDirection, page, size, search }) => ({
        url: API_ENDPOINTS.ATTENDANCE_REPORT.GET_EMPLOYEE_ATTENDANCE_REPORT(month, sortDirection, page, size, search),
      }),

      providesTags: ["AttendanceReport"],
    }),
  }),
});

export const { useGetAttendanceReportQuery } = attendanceReportListApi;